import styled from "styled-components";
import { PageContentHeaderActionsWrapper } from "../../../../../styles/page";

export const TapPage = styled.div`
  // display: flex;
  // width: 250px;
  // height: 50px;
  // background: #2F3332;
  // padding: 8.5px 10px;
  // gap: 10px;
  // border-radius: 26.98px;
  // box-sizing: border-box;

  > .purple {
    color: white;
    border-radius: 30.35px;
    background: #6436e7;
  }

  > div {
    width: 229px;
    height: 34px;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    color: #b7b7b7;
    line-height: 34px;
    cursor: pointer;
  }
`;

export const MainHeaderWrapper = styled(PageContentHeaderActionsWrapper)`
  display: flex;
  align-items: center;

  > .sendCount {
    display: flex;
    flex-direction: column;
    gap: 0px;
    font-size: 16px;

    > div {
      display: flex;
      justify-content: space-between;
      gap: 40px;
    }

    span {
      font-weight: 600;
    }

    .countTitle {
      font-weight: 500;
    }
  }

  .messageHistory {
    width: 176px;
    height: 50px;
    padding: 10px 12px 10px 12px;
    border-radius: 15px;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    background: #bebebe;
    box-sizing: border-box;
    color: white;
    cursor: pointer;
  }
`;

export const PushContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > .pushContent {
    display: flex;
    flex-direction: column;
    gap: 40px;

    > .pushTitleWrapper {
      display: flex;
      flex-direction: column;
      gap: 10px;

      > div {
        font-size: 22px;
        font-weight: 600;
      }

      > input[type="text"] {
        width: 611px;
        height: 36px;
        padding: 5px 8px 5px 8px;
        border-radius: 2.7px;
        border: 0.67px solid #b7b7b7;
        font-size: 15px;
        font-family: Pretendard;
        font-size: 15px;
        font-weight: 600;
      }

      > textarea {
        width: 611px;
        height: 72px;
        padding: 5px 8px 5px 8px;
        border-radius: 2.7px;
        border: 0.67px solid #b7b7b7;
        resize: none;
        overflow: auto;
        font-size: 15px;
        line-height: 1.5;
        color: #121212;
        font-family: Pretendard;
        font-size: 15px;
        font-weight: 600;
      }

      input[type="text"]::placeholder {
        color: #808080; /* 원하는 색상으로 변경 */
      }
      textarea::placeholder {
        color: #808080; /* 원하는 색상으로 변경 */
      }

      > .pushTitle {
        width: 611px;
        height: 36px;
        padding: 5px 8px 5px 8px;
        border-radius: 2.7px;
        border: 0.67px solid #b7b7b7;
        background: #f0f0f0;
        font-size: 15px;
        color: #808080;
      }

      > .pushText {
        width: 611px;
        height: 72px;
        padding: 5px 8px 5px 8px;
        border-radius: 2.7px;
        border: 0.67px solid #b7b7b7;
        background: #f0f0f0;
        resize: none;
        overflow: auto;
        font-size: 15px;
        line-height: 1.5;
        color: #808080;
      }

      span {
        font-size: 20px;
        font-weight: 600;
        color: #808080;
        margin-right: 15px;
      }

      input[type="radio"] {
        appearance: none;
        width: 24px;
        height: 24px;
        border: 2px solid #b7b7b7;
        border-radius: 50%;
        background-color: #fff;
        vertical-align: bottom;
        cursor: pointer;
      }

      input[type="radio"]:checked {
        background-color: #8359f7;
        border: 4px solid white;
        box-shadow: 0 0 0 1.6px #8359f7;
      }

      input[type="datetime-local"] {
        margin-top: 10px;
        width: 611px;
        height: 36px;
        padding: 5px 8px 5px 8px;
        border-radius: 2.7px;
        border: 0.67px solid #b7b7b7;
        color: #808080;
        font-family: Inter;
        font-size: 15px;
        font-weight: 600;
      }
    }

    > .pinpoint {
      display: flex;
      gap: 15px;

      > .pinpointGuide {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        > .title {
          font-size: 22px;
          font-weight: 600;
        }

        > .guide {
          > div {
            width: 161px;
            height: 34px;
            padding: 8px 25px;
            border-radius: 15px;
            background: #8f1212;
            box-sizing: border-box;
            color: white;
            font-size: 15px;
            font-weight: 700;
          }
        }
      }
      span {
        margin-top: 10px;
        font-size: 15px;
        font-weight: 500;
        color: #1a191a;
        display: block;
      }
    }
  }

  > .buttonGroup {
    display: flex;
    gap: 20px;

    > div {
      width: 176px;
      height: 50px;
      padding: 10px 12px 10px 12px;
      border-radius: 15px;
      background: #bebebe;
      color: white;
      font-size: 15px;
      font-weight: 700;
      text-align: center;
      box-sizing: border-box;
      line-height: 30px;
      cursor: pointer;
    }

    > .purple {
      background: #6436e7;
    }
  }
`;

export const LocationInfoBox = styled.div`
  #map {
    width: 400px;
    height: 237px;
    border: 1px solid #b7b7b7;

    #marker {
      width: 9px;
      height: 9px;
      background: #6436e7;
      border-radius: 50%;
      border: 3px solid #fff;
    }
  }
`;

export const AlertContainer = styled.div`
  width: 514px;
  height: 275px;
  top: 40%;
  left: 32%;
  padding: 70px 15px 24px 15px;
  border-radius: 12px;
  background: #fff;
  position: absolute;
  z-index: 1000;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > span {
    font-family: Pretendard;
    font-size: 25px;
    font-weight: 600;
  }

  > .redButton {
    width: 484px;
    height: 48px;
    padding: 15px 140px 15px 140px;
    border-radius: 8px;
    background: #d91818;
    color: #fff;
    box-sizing: border-box;
  }
`;

export const PushWarning = styled.div`
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 600;
  color: #808080;
  text-align: right;
  margin-top: 15px;
  margin-bottom: 15px;
`;
